import {ShieldMobile} from 'modules/events/components/ShieldMobile';
import {IDrinkType} from 'modules/events/types';
import {FC} from 'react';

interface IProps {
    drinkType: IDrinkType;
}

// Заготовка на будущее
// По дизайну может быть несколько шильдиков, но api пока отдает только 1
export const ShieldListMobile: FC<IProps> = ({drinkType}) => {
    const {code, title} = drinkType;

    return (
        <div>
            <ShieldMobile src={`/images/shields/${code}.svg`} title={title} />
        </div>
    );
};
